module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAQAQMAAADan0jAAAAAA1BMVEXmAAAKFZHIAAAAC0lEQVQI12MY5gAAAOAAAR8Cr9MAAAAASUVORK5CYII="